import { productTypeCharacteristics } from "@/core/utils/product-type-characteristics";
import { productSeriesColor } from "./product-badge-variant";
import { slugify } from "./slugify";

export function buildSeries() {
  return Object.entries(productTypeCharacteristics).map(([typeStr, info]) => {
    const key = slugify(info.name);
    const type = Number(typeStr);
    return {
      type,
      label: info.name,
      longLabel: info.name,
      key,
      color: info.color,
      gradientId: `${key}-gradient`,
      description: info.description,
      // Cor do ponto da legenda (BadgeStatus do Figma), p/ linha e legenda baterem.
      hexaColor: productSeriesColor(type),
    };
  });
}
